module.exports = __webpack_public_path__ + "static/media/om.957fa2cc.svg";